import React, { Component } from 'react';

import { connect } from 'react-redux';
import * as actions from '@store/actions';
import { Container, Row, Col, Modal, ModalBody } from 'reactstrap';
import LabelInput from '@components/LabelInput/LabelInput';
import CloudPanel from '@components/CloudPanel/CloudPanel';
import ProgressBox from '@components/ProgressBox/ProgressBox';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class LoginForm extends Component {
  state = {
    email: '',
    password: '',
    modalActive: false
  };

  updateForm = (event, name) => {
    this.setState({
      [name]: event.target.value
    });
  };

  toggleModal = () => {
    const current = this.state.modalActive;
    this.setState({
      modalActive: !current
    });
  };

  submitHandler = event => {
    event.preventDefault();
    this.props.onAuth(this.state.email, this.state.password);
  };

  render = () => {
    const isMobile = this.props.pageWidth < 992;
    let className = '';
    if (isMobile) {
      className = 'pt-5 mt-5 mb-5';
    } else {
      className = 'abs-container d-flex align-items-center h-100';
    }

    return (
      <CloudPanel id={this.props.id} screenHeight={this.props.pageHeight}>
        <div className={className}>
          <Container>
            <Row>
              <Col xs={12} md={{ offset: 6, size: 6 }}>
                <div className="p-4 background-white px-5 position-relative">
                  {this.props.loading && (
                    <ProgressBox
                      text={'Submitting ...'}
                      icon={<FontAwesomeIcon icon={['far', 'spinner']} spin />}
                    />
                  )}

                  <form onSubmit={this.submitHandler}>
                    <div className={'unified-header mb-3'}>My Account</div>
                    {this.props.error !== null && (
                      <div
                        className={'alert alert-danger'}
                        dangerouslySetInnerHTML={{ __html: this.props.error }}
                      />
                    )}
                    <div className={'pb-4'}>
                      <LabelInput
                        label={'Email'}
                        type={'email'}
                        name={'quoting_email'}
                        className={'pb-4'}
                        value={this.state.email}
                        onChange={event => this.updateForm(event, 'email')}
                      />
                    </div>
                    <div className={'pb-4'}>
                      <LabelInput
                        label={'Password'}
                        type={'password'}
                        name={'quoting_password'}
                        value={this.state.password}
                        onChange={event => this.updateForm(event, 'password')}
                      />
                      <div
                        className={
                          'pt-1 color-red font-sm text-right pointer asap-medium float-right'
                        }
                        onClick={this.toggleModal}
                      >
                        Forgot Password?
                      </div>
                    </div>
                    <div className={'color-red clear pt-3'}>
                      <span className={'asap-bold'}>NOTE:</span> This login is
                      for SuiteKey Members only. The SuiteDeals login page can
                      be found{' '}
                      <a
                        className={'asap-bold red-link'}
                        href={'https://account.jetsuite.com/suitedeal/'}
                      >
                        here
                      </a>
                      .
                    </div>

                    <div className={'mt-4'}>
                      <button className={'btn btn-default btn-block'}>
                        Login
                      </button>
                    </div>
                  </form>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <Modal
          isOpen={this.state.modalActive}
          toggle={this.toggleModal}
          className={'h-100 d-flex flex-column justify-content-center my-0'}
        >
          <ModalBody style={{ backgroundColor: '#eeeeee' }}>
            <div className="p-3">
              Forgot Password? Please contact guest services at{' '}
              <a href={'mailto:guestservices@jetsuite.com'}>
                guestservices@jetsuite.com
              </a>{' '}
              for your password information.
            </div>
          </ModalBody>
        </Modal>
      </CloudPanel>
    );
  };
}

const mapStateToProps = state => {
  return {
    loading: state.auth.loading,
    error: state.auth.error
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onAuth: (email, password) => dispatch(actions.auth(email, password))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/Quoting/LoginForm/LoginForm.jsx